import { createAsyncThunk } from "@reduxjs/toolkit";
import { userService } from "../../services";

const getAuthUser = createAsyncThunk(
    'user/getAuthUser',
    async (payload, ThunkAPI) => {
        try{
            const response = await userService.authUser();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const setImage = createAsyncThunk(
    'user/setImage',
    async (payload, ThunkAPI) => {
        try{
            const response = await userService.setImage();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const logout = createAsyncThunk(
    'user/logout',
    async (payload, ThunkAPI) => {
        try{
            const response = await userService.logout();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateProfileDetails = createAsyncThunk(
    'user/updateProfileDetails',
    async (payload, ThunkAPI) => {
        try{
            const response = await userService.updateProfileDetails(payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updatePassword = createAsyncThunk(
    'user/updatePassword',
    async (payload, ThunkAPI) => {
        try{
            const response = await userService.updatePassword(payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response?.data);
        }
    }
);


const userLoginActivity = createAsyncThunk(
    'user/userLoginActivity',
    async (payload, ThunkAPI) => {
        try{
            const response = await userService.userLoginActivity(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response?.data);
        }
    }
);

export {
    getAuthUser,
    setImage,
    logout,
    updateProfileDetails,
    updatePassword,
    userLoginActivity,
}